import $ from 'jquery';


const init = (opts = {}) => {
    // defaults
    const defaults = {
        selector: {
            modal: '.js-dynamic-content-modal'
        }
    };

    // extend options
    const options = $.extend(true, defaults, opts);

    // replace content inside modal
    $(options.selector.modal).on('show.bs.modal', function (event) {
        const $modal = $(this);

        const $trigger = $(event.relatedTarget);
        const title = $trigger.data('title');
        const content = $trigger.data('content');
        const footer = $trigger.data('footer');

        $modal.find('.modal-title').text(title);
        $modal.find('.modal-body').html(content);
        $modal.find('.modal-footer').html(footer);
    });

};

export default {
    init
};
